import * as React from 'react';
const SvgOnlinePlatform = (props) => (
  <svg viewBox="0 0 124 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M122 22.757H2M101.13 12.378h-7.826M114.174 12.378h-7.826M88.087 12.378H80.26M56.783 12.378H9.826M30.695 33.135h-18.26v18.162h18.26V33.135Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M122 2H2v96h120V2ZM38.522 35.73h26.086M38.522 46.108h7.826M51.565 46.108h28.696"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M30.695 63.232h-18.26v18.163h18.26V63.232ZM38.522 65.827h26.086M38.522 76.205h7.826M51.565 76.205h28.696"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgOnlinePlatform;
